<template>
    <form
        class="t-form t-filter__class"
        :class="{ _disabled: infoForm.disabledForm }"
        @submit.stop.prevent="submitForm()"
    >
        <div class="t-feedback__content">
            <div
                v-for="(item, index) in cmpForm"
                class="t-feedback__item"
                :class="[{
                    _radio: item.type === 'radio',
                    _full: !notFull && (item.name === 'typeRequest' || item.type === 'textarea' || item.type === 'dropzone' ||
                        item.type === 'select' || item.type === 'images'),
                    _top: item.type === 'textarea',
                    _hidden: item.type === 'view-hidden'
                }, item.addClass]"
            >
                <input
                    v-if="item.type === 'view-hidden'"
                    type="hidden"
                    :value="item.defaultValue"
                />

                <div
                    v-if="item.title"
                    class="t-form__label"
                    :class="{ _radio: item.type === 'radio' }"
                >
                    {{ item.title }}
                    <span v-if="item.requiredField">*</span>
                </div>

                <select-custom-cmp
                    :class="{_white: classWhite}"
                    v-if="item.type === 'select'"
                    :data="item"
                    :multi="item.typeField === 8"
                    ref="selectCustom"
                >
                </select-custom-cmp>

                <input
                    v-if="item.type === 'text'"
                    class="t-input"
                    :class="{ _error: item.error, _valid: item.valid, _disabled: item.disabled }"
                    :type="item.type"
                    :placeholder="item.hintField"
                    v-model="item.value"
                    :disabled="item.disabled"
                    @focus="handleFieldFocus(item)"
                />

                <input
                    v-if="item.type === 'number'"
                    class="t-input"
                    :class="{ _error: item.error, _valid: item.valid }"
                    type="text"
                    :placeholder="item.hintField"
                    v-model="item.value"
                    @keydown="keydownNumber($event)"
                    @input="deleteChar(item)"
                    @focus="handleFieldFocus(item)"
                />

                <masked-input
                    v-if="item.type === 'phone'"
                    class="t-input"
                    :class="{ _error: item.error, _valid: item.valid }"
                    :placeholder="item.hintField"
                    v-model="item.value"
                    :mask="{pattern: pattern}"
                    @input="handleFieldFocus(item)"
                    :ref="index"
                />

                <textarea
                    v-if="item.type === 'textarea'"
                    :class="{ _error: item.error, _valid: item.valid }"
                    class="t-textarea"
                    :placeholder="item.hintField"
                    v-model="item.value"
                    @focus="handleFieldFocus(item)"
                >
                </textarea>

                <div v-if="item.type === 'radio'" class="t-form__radio" :class="{_green: !classWhite}">
                    <template v-for="(radio, idxRadio) in item.list">
                        <input
                            v-if="idxRadio === 0 && item.id !== 'work' && item.id !== 'client'"
                            checked
                            :id="item.id.toString() + idxRadio"
                            :name="item.id"
                            class="t-radio"
                            :value="radio.id"
                            @change="changeRadio(index, $event)"
                            :type="item.type"
                        />
                        <input
                            v-else
                            :id="item.id.toString() + idxRadio"
                            :name="item.id"
                            class="t-radio"
                            :value="radio.id"
                            @change="changeRadio(index, $event)"
                            :type="item.type"
                        />

                        <label
                            :for="item.id.toString() + idxRadio"
                            class="t-radio__text"
                            :class="{_error: item.error}"
                        >
                            {{ radio.label }}
                        </label>
                    </template>
                </div>

                <input
                    v-if="item.type === 'date-picker'"
                    class="t-input _date-picker"
                    :class="{'_error': item.error, '_valid': item.valid}"
                    :type="item.type"
                    :placeholder="item.hintField"
                    :value="formatDate(item.value)"
                    @focus="handleFieldFocus(item)"
                    @click="setVisibleDatePicker(index)"
                    readonly
                />
                <transition name="fade">
                    <div
                        v-if="item.type === 'date-picker' && visibleDatePicker === index"
                        class="t-filter__date-picker"
                        @click.stop=""
                    >
                        <v-date-picker
                            v-model="item.value"
                            :first-day-of-week="1"
                            @input="visibleDatePicker = -1"
                            :locale="$router.history.base !== '' ? $router.history.base.substring(1) : 'ru'"
                            no-title
                        >
                        </v-date-picker>
                    </div>
                </transition>

                <div
                    v-if="item.type === 'date-picker'"
                    class="t-input__calendar"
                    :class="{_white: classWhite}"
                >
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6.88889 6.11111V3V6.11111ZM13.1111 6.11111V3V6.11111ZM6.11111 9.22222H13.8889H6.11111ZM4.55556 17H15.4444C15.857 17 16.2527 16.8361 16.5444 16.5444C16.8361 16.2527 17 15.857 17 15.4444V6.11111C17 5.69855 16.8361 5.30289 16.5444 5.01117C16.2527 4.71944 15.857 4.55556 15.4444 4.55556H4.55556C4.143 4.55556 3.74733 4.71944 3.45561 5.01117C3.16389 5.30289 3 5.69855 3 6.11111V15.4444C3 15.857 3.16389 16.2527 3.45561 16.5444C3.74733 16.8361 4.143 17 4.55556 17Z" stroke="#00b0bd" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>

                <div
                    v-if="item.type === 'checkbox'"
                    class="t-form__checkbox"
                    :class="{_white: classWhite, '_error': item.error}"
                    v-for="(checkbox, idxCheckbox) in item.list"
                >
                    <input
                        :checked="checkbox.checked"
                        :id="checkbox.id.toString() + idxCheckbox"
                        :name="checkbox.id"
                        class="t-checkbox"
                        :type="item.type"
                        @change="checkbox.checked = !checkbox.checked; item.error = false;"
                    >
                    <label :for="checkbox.id.toString() + idxCheckbox" class="t-checkbox__text">{{ checkbox.label }}</label>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M16.7064 5.29279C16.8939 5.48031 16.9992 5.73462 16.9992 5.99979C16.9992 6.26495 16.8939 6.51926 16.7064 6.70679L8.70643 14.7068C8.5189 14.8943 8.2646 14.9996 7.99943 14.9996C7.73427 14.9996 7.47996 14.8943 7.29243 14.7068L3.29243 10.7068C3.11027 10.5182 3.00948 10.2656 3.01176 10.0034C3.01403 9.74119 3.1192 9.49038 3.30461 9.30497C3.49002 9.11956 3.74083 9.01439 4.00303 9.01211C4.26523 9.00983 4.51783 9.11063 4.70643 9.29279L7.99943 12.5858L15.2924 5.29279C15.48 5.10532 15.7343 5 15.9994 5C16.2646 5 16.5189 5.10532 16.7064 5.29279Z" fill="#00b0bd"/>
                    </svg>
                </div>

                <div v-if="item.type === 'images'" class="t-form-images">
                    <div
                        class="t-form__checkbox t-form-images__item"
                        :class="{_white: classWhite}"
                        v-for="(images, idxImages) in item.list"
                    >
                        <div class="t-form-images__img">
                            <img :src="images.image" alt="">
                            <input
                                :checked="images.checked"
                                :id="images.id + idxImages"
                                :name="images.id"
                                class="t-checkbox"
                                type="checkbox"
                                @change="images.checked = !images.checked"
                            >
                            <label :for="images.id + idxImages" class="t-checkbox__text"></label>
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M16.7064 5.29279C16.8939 5.48031 16.9992 5.73462 16.9992 5.99979C16.9992 6.26495 16.8939 6.51926 16.7064 6.70679L8.70643 14.7068C8.5189 14.8943 8.2646 14.9996 7.99943 14.9996C7.73427 14.9996 7.47996 14.8943 7.29243 14.7068L3.29243 10.7068C3.11027 10.5182 3.00948 10.2656 3.01176 10.0034C3.01403 9.74119 3.1192 9.49038 3.30461 9.30497C3.49002 9.11956 3.74083 9.01439 4.00303 9.01211C4.26523 9.00983 4.51783 9.11063 4.70643 9.29279L7.99943 12.5858L15.2924 5.29279C15.48 5.10532 15.7343 5 15.9994 5C16.2646 5 16.5189 5.10532 16.7064 5.29279Z" fill="#00b0bd"/>
                            </svg>
                        </div>
                        <div class="t-form-images__text">{{ images.label }}</div>
                    </div>
                </div>

                <vue-dropzone
                    v-if="item.type === 'dropzone'"
                    id="dropzone"
                    class="_dynamic _white"
                    :class="{ _error: item.error, _valid: item.valid }"
                    ref="dropzone"
                    :options="dropzoneOptions"
                    :useCustomSlot="true"
                >
                    <div class="dropzone-custom-title">
                        {{ item.hintField }}
                    </div>
                </vue-dropzone>

                <ui-dadata-organisation-autocomplete
                    v-if="item.type === 'dadata-organisation'"
                    :placeholder="item.hintField"
                    :value="item.value"
                    @update:value="v => item.value = v"
                    :error="item.error"
                    :valid="item.valid"
                    :disabled="!isUserAuth && !location"
                    :location="location || null"
                    @focus="handleFieldFocus(item)"
                />

                <ui-dadata-city-autocomplete
                    v-if="item.type === 'dadata-city'"
                    :placeholder="item.hintField"
                    :value="item.value"
                    @update:value="v => {
                      item.value = v
                      location = v
                    }"
                    :error="item.error"
                    :valid="item.valid"
                    @focus="handleFieldFocus(item)"
                />

                <svg class="t-form__error-svg" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1L9 9" stroke="white" stroke-width="2"/>
                    <path d="M9 1L1 9" stroke="white" stroke-width="2"/>
                </svg>

                <div v-if="item.error && item.textError" class="t-feedback__error">{{ item.textError }}</div>
            </div>
        </div>

        <div
            v-if="!$route.fullPath.includes('/lk') || personalData"
            class="t-personal-data"
            :class="{ _error: infoForm.errorPersonalData }"
        >
            <input
                @change="changePersonalDataFrom()"
                type="checkbox"
                :id="'personal-data-feedback' + formInfo.id"
                class="t-personal-data__input"
            />
            <label :for="'personal-data-feedback' + formInfo.id">
                <svg width="16" height="12" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M10.4213 0.944336L11.3327 1.63582L4.82917 7.88078C4.71347 7.99188 4.54763 8.05545 4.37347 8.05545C4.19932 8.05545 4.03347 7.99188 3.91777 7.88078L0.666016 4.7583L1.57741 4.06681L4.37347 6.75171L10.4213 0.944336Z" fill="white"/>
                </svg>
                <span>
                    {{ $root.staticText.forms.agree }}
                    <span class="t-personal-data__link" @click.stop.prevent="clickToPage">
                        {{$root.staticText.forms.personalData}}
                    </span>
                </span>
            </label>
        </div>

        <div v-if="infoForm.addCheck.visible" class="t-personal-data _add-check">
            <input
                @change="changeAddCheck()"
                type="checkbox"
                :id="'personal-data-form' + formInfo.id"
                class="t-personal-data__input"
            />
            <label :for="'personal-data-form' + formInfo.id">
                <svg width="16" height="12" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M10.4213 0.944336L11.3327 1.63582L4.82917 7.88078C4.71347 7.99188 4.54763 8.05545 4.37347 8.05545C4.19932 8.05545 4.03347 7.99188 3.91777 7.88078L0.666016 4.7583L1.57741 4.06681L4.37347 6.75171L10.4213 0.944336Z" fill="white"/>
                </svg>
                {{ $root.staticText.forms.agreePostPhoto }}
            </label>
        </div>

        <vue-recaptcha
            ref="recaptcha"
            size="invisible"
            :sitekey="$root.sitekeyRecaptcha"
            :load-recaptcha-script="true"
            @verify="onCapchaRegister"
            @expired="onCaptchaExpired"
            @error="errorCaptcha"
        />
        <div class="t-feedback__raw">
            <div
                v-if="lkPersonalData"
                class="t-personal-data _lk"
                :class="{ _error: infoForm.errorPersonalData }"
            >
                <input
                    @change="changePersonalDataFrom()"
                    type="checkbox"
                    :id="'personal-data-feedback' + formInfo.id"
                    class="t-personal-data__input"
                />
                <label :for="'personal-data-feedback' + formInfo.id">
                    <svg width="16" height="12" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M10.4213 0.944336L11.3327 1.63582L4.82917 7.88078C4.71347 7.99188 4.54763 8.05545 4.37347 8.05545C4.19932 8.05545 4.03347 7.99188 3.91777 7.88078L0.666016 4.7583L1.57741 4.06681L4.37347 6.75171L10.4213 0.944336Z" fill="white"/>
                    </svg>
                    <span>
                    {{ $root.staticText.forms.agree }}
                    <span class="t-personal-data__link" @click.stop.prevent="clickToPage">
                        {{$root.staticText.forms.personalData}}
                    </span>
                </span>
                </label>
            </div>
            <button class="t-btn _big t-feedback__btn" :class="{_white: classWhite, _green: !classWhite}">
                {{ button }}
            </button>
        </div>
    </form>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';

import selectCustom from '@components/ui-components/select-custom/select-custom-dynamic.vue';
import vue2Dropzone from 'vue2-dropzone';
import VueRecaptcha from 'vue-recaptcha';
import formDynamicMixin from '../mixins/form-dynamic';
import UIDadataOrganisationAutocomplete from "@ui/dadata-autocomplete/dadata-organisation-autocomplete.vue";
import UIDadataCityAutocomplete from "@ui/dadata-autocomplete/dadata-city-autocomplete.vue";

export default {
    mixins: [ formDynamicMixin ],
    props: {
        formInfo: {
            type: Object,
        },
        button: {
            type: String,
        },
        classWhite: {
            type: Boolean,
            default: true
        },
        check: {
            type: Boolean,
            default: false,
        },
        action: {
            type: String,
            default: 'feedback/send',
        },
        leadId: {
            type: String,
        },
        personalData: {
            type: Boolean,
            default: false,
        },
        lkPersonalData: {
            type: Boolean,
            default: false,
        },
        checkError: {
            type: Boolean,
            default: false,
        },
        notFull: {
            type: Boolean,
            default: false,
        },
        isReload: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        vueDropzone: vue2Dropzone,
        VueRecaptcha,
        'select-custom-cmp': selectCustom,
        'ui-dadata-organisation-autocomplete': UIDadataOrganisationAutocomplete,
        'ui-dadata-city-autocomplete': UIDadataCityAutocomplete,
    },
    computed: {
        ...mapGetters('modal', ['modalState']),
        ...mapGetters('lk', ['isAuth']),
        ...mapGetters('locale', ['region']),
    },
    methods: {
        ...mapActions('modal', ['modalClose']),
        clickToPage() {
            if (this.$route.name === 'UserAgreement') {
                this.modalClose();
            } else {
                window.open(
                    `${window.location.protocol}//${window.location.host}${this.$router.history.base}/user-agreement`,
                    '_blank'
                );
            }
        },
        setVisibleDatePicker(index) {
            this.visibleDatePicker = this.visibleDatePicker === index ? -1 : index;
        },
        changePersonalDataFrom() {
            this.infoForm.isPersonalData = !this.infoForm.isPersonalData;
            this.infoForm.errorPersonalData = !this.infoForm.isPersonalData;
        },
        changeAddCheck() {
            this.infoForm.addCheck.is = this.infoForm.addCheck.is === 0 ? 1 : 0;
            //this.infoForm.addCheck.error = !this.infoForm.addCheck.is;
        },
        changeRadio(index, event) {
            this.cmpForm[index].error = false
            this.cmpForm[index].valid = true
            this.cmpForm[index].value = event.target.value;
        },
        deleteChar(item) {
            item.value = item.value.replace(/\D/g, '');
        },
        keydownNumber(event) {
            if (
                // Разрешаем: backspace, delete, tab и escape
                event.keyCode === 46 || event.keyCode === 8 || event.keyCode === 9 || event.keyCode === 27 ||
                // Разрешаем: Ctrl+A
                (event.keyCode === 65 && (event.ctrlKey || event.metaKey)) ||
                // Разрешаем: Ctrl+V
                (event.keyCode === 86 && (event.ctrlKey || event.metaKey)) ||
                // Разрешаем: home, end, влево, вправо
                (event.keyCode >= 35 && event.keyCode <= 39)
            ) {

            } else {
                // Запрещаем все, кроме цифр на основной клавиатуре, а так же Num-клавиатуре
                if ((event.keyCode < 48 || event.keyCode > 57) && (event.keyCode < 96 || event.keyCode > 105)) {
                    event.preventDefault();
                }
            }
        },
        formatDate(date) {
            if (!date) return null;

            const [year, month, day] = date.split('-');
            return `${day}.${month}.${year}`;
        },
    }
};
</script>

<style lang="sass"></style>



// WEBPACK FOOTER //
// src/templates/components/base/form-dynamic.vue